<template>
    <div>
        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userId" label="用户ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="level" label="级别" show-overflow-tooltip></el-table-column>
            <el-table-column prop="countryCode" label="国家编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contact" label="联系方式" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freezeCoin" label="冻结币种" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freezeAmount" label="冻结数量" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updatePhoneDialog(scope.row)">修改</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog :visible.sync="dialogVisible" title="修改" width="500px" @close="clearDataOne">
            <el-form :model="updateData" :rules="updateRules" ref="updateForm">
                <el-form-item label="国家编号：">
                    <el-input v-model="updateData.countryCode" placeholder="国家编号" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="联系方式：">
                    <el-input v-model="updateData.contact" placeholder="联系方式" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible==false">关 闭</el-button>
                <el-button type="danger" @click="updatePhone">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../../store';
    import api from '../../api';

    export default {
        name: 'MerchantList',
        components: {},
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {page: 1, size: 10},
                dialogVisible: false,
                updateData: {
                    id: "",
                    countryCode: "",
                    contact: "",
                },
                updateRules: {
                    "countryCode": [{required: true, message: "请输入国家编码"}],
                    "contact": [{required: true, message: "请输入联系方式"}]
                }
            }
        },
        methods: {
            getMerchantList() {
                api.getMerchantList(this.queryParams).then(({data}) => {
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            updatePhoneDialog(row) {
                this.updateData.id = row.id;
                this.updateData.countryCode = row.countryCode;
                this.updateData.contact = row.contact;
                this.dialogVisible = true;
            },
            updatePhone() {
                this.$refs["updateForm"].validate(valid => {
                    if (valid) {
                        api.updateMerchantContact(this.updateData).then(({data}) => {
                            this.$message.success('保存成功！');
                            this.getMerchantList();
                            this.dialogVisible = false;
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getMerchantList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getMerchantList();
            },
            clearDataOne() {
                this.updateData = {
                    id: "",
                    countryCode: "",
                    contact: "",
                };
            }

        },
        created() {
            this.getMerchantList();
        }
    };
</script>

<style lang="less" scoped>

</style>

